import { type LifecycleState } from '@/models/lifecycleState';
import { type Pagination } from '@/models/pagination';

export const claimFrequencies = [
  'once',
  'minute',
  'hourly',
  'daily',
  'weekly',
  'monthly',
  'yearly',
] as const;

export type ClaimFrequency = (typeof claimFrequencies)[number];

/** Labels for tooltips on frequency badges. */
export const getFrequencyDescription = (frequency: ClaimFrequency): string => {
  const descriptions: Record<ClaimFrequency, string> = {
    once: 'Can be claimed once per player',
    minute: 'Can be claimed once every minute',
    hourly: 'Can be claimed once every hour',
    daily: 'Can be claimed once per day',
    weekly: 'Can be claimed once per week',
    monthly: 'Can be claimed once per month',
    yearly: 'Can be claimed once per year',
  };
  return descriptions[frequency];
};

export interface Gift {
  gift_id: string;
  game_code: string;
  sandbox_code: string;
  gift_code: string;
  name: string;
  available_at: string;
  /** When missing or null, the gift does not expire. */
  expires_at?: string | null;
  claim_frequency: ClaimFrequency;
  item_id: string;
  item_quantity: number;
  state: LifecycleState;
  created_at: string;
  updated_at: string;
  published_at?: string;
  publication_failure_code?: string;
}

export interface ListGiftsResponse {
  gifts: Gift[];
  pagination: Pagination;
}

export interface GiftsFilters {
  game_code?: string;
  sandbox_code?: string;
  state?: LifecycleState | 'all';
  claim_frequency?: ClaimFrequency | 'all';
  search?: string;
}
